import * as React from 'react';
import { ProblemBanner } from './ProblemBanner';
import { ReliableBanner } from './ReliableBanner';
import { IReliability } from '../../types/reliability';
import { EStatus } from '../../types/reliability/checkStatus';

interface IRightReliableLabelRedesignedProps {
  onReliableClick(event: React.MouseEvent<HTMLElement>): void;
  onProblemClick(event: React.MouseEvent<HTMLElement>): void;
  reliability: IReliability | null;
}

export const ReliableBlockRedesigned = ({
  onReliableClick,
  onProblemClick,
  reliability,
}: IRightReliableLabelRedesignedProps) => {
  if (!reliability) {
    return null;
  }

  const isReliable = reliability.checkStatus.status === EStatus.Reliable;

  if (isReliable) {
    return <ReliableBanner onClick={onReliableClick} title={reliability.banner.title} />;
  }

  return <ProblemBanner reliabilityBanner={reliability.banner} onClick={onProblemClick} />;
};
